import React from "react";
import Select, { components } from "react-select";

const groupStyles = {
  fontWeight: "bold",
  fontSize: "23px",
  color: "#bbb",
  display: "flex",
  marginLeft: "-7px",
  padding: "5px 0 2px 0",
};

const GroupHeading = (props) => (
  <div style={groupStyles}>
    <components.GroupHeading {...props} />
  </div>
);

export const SingleSelect = (props) => (
  <Select
    isClearable={props.isClearable !== false}
    options={props.selectList}
    value={setSelectedValue(
      props.selectList,
      props.parentObj.state[props.stateProperty],
    )}
    components={{ GroupHeading }}
    styles={{
      groupHeading: (base) => ({
        ...base,
      }),
    }}
    onChange={(option) => {
      let selectedValue = option ? option.value : "";

      props.parentObj.setState({ [props.stateProperty]: selectedValue });

      //setando direto no state para poder usar na funcao onchange
      props.parentObj.state[props.stateProperty] = selectedValue;
      if (props.onChange) {
        props.onChange();
      }
    }}
    placeholder="Selecione..."
  />
);

const setSelectedValue = function (selectList, value) {
  if (!selectList || selectList.length === 0) return false;

  if (!value) return false;

  for (let i = 0; i < selectList.length; i++) {
    var el = selectList[i];

    if (el.value && el.value == value) {
      return el;
    }

    if (el.options && el.options.length > 0) {
      var obj = setSelectedValue(el.options, value);

      if (obj) return obj;
    }
  }

  return false;
};

export default SingleSelect;
